import React from "react";
import { cn } from "@/utils/utils";
import { EmployeeDirectorySpecialty } from "@/modules/hub/features/EmployeeDirectory/api/fetchEmployeeDirectoryData/types";

interface SpecialtyFiltersProps {
  options: EmployeeDirectorySpecialty[];
  selectedUuids: string[];
  onToggle: (uuid: string) => void;
}

const SpecialtyFilters: React.FC<SpecialtyFiltersProps> = ({
  options,
  selectedUuids,
  onToggle,
}) => {
  if (options.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-wrap items-center justify-center gap-3 py-4">
      <span className="text-xs font-semibold tracking-widest text-gray-500 dark:text-gray-400 uppercase">
        Specialty
      </span>
      {options.map((option) => {
        const isSelected = selectedUuids.includes(option.uuid);
        return (
          <button
            className={cn(
              "rounded-full border px-4 py-1.5 text-sm transition-colors",
              isSelected
                ? "border-primary bg-primary text-white"
                : "border-gray-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-gray-700 dark:text-gray-200 hover:border-gray-400 dark:hover:border-slate-500",
            )}
            key={option.uuid}
            onClick={() => onToggle(option.uuid)}
            type="button"
          >
            {option.name}
          </button>
        );
      })}
    </div>
  );
};

export default SpecialtyFilters;
